export enum PermissionEnum {
  OntologiesCreate = 1000,
  OntologiesRead = 1001,
  OntologiesUpdate = 1002,
  OntologiesDelete = 1003,
  EventCreate = 2000,
  EventRead = 2001,
  EventUpdate = 2002,
  EventDelete = 2003,
  UserRightsCreate = 3000,
  UserRightsRead = 3001,
  UserRightsUpdate = 3002,
  UserRightsDelete = 3003,
  UserCreate = 4000,
  UserRead = 4001,
  UserUpdate = 4002,
  UserDelete = 4003,
  IncidentFolderCreate = 5000,
  IncidentFolderRead = 5001,
  IncidentFolderUpdate = 5002,
  IncidentFolderDelete = 5003,
  IncidentCreate = 6000,
  IncidentRead = 6001,
  IncidentUpdate = 6002,
  IncidentDelete = 6003,
  InjectionCreate = 7000,
  InjectionRead = 7001,
  InjectionUpdate = 7002,
  InjectionDelete = 7003,
  ActionCreate = 8000,
  ActionRead = 8001,
  ActionUpdate = 8002,
  ActionDelete = 8003,
  OutcomeCreate = 9000,
  OutcomeRead = 9001,
  OutcomeUpdate = 9002,
  OutcomeDelete = 9003,
  ObservationTaskCreate = 10000,
  ObservationTaskRead = 10001,
  ObservationTaskUpdate = 10002,
  ObservationTaskDelete = 10003,
  ObjectiveCreate = 11000,
  ObjectiveRead = 11001,
  ObjectiveUpdate = 11002,
  ObjectiveDelete = 11003,
  StateCreate = 12000,
  StateRead = 12001,
  StateUpdate = 12002,
  StateDelete = 12003,
  TransactionCreate = 13000,
  TransactionRead = 13001,
  TransactionUpdate = 13002,
  TransactionDelete = 13003,
  ResourceCreate = 14000,
  ResourceRead = 14001,
  ResourceUpdate = 14002,
  ResourceDelete = 14003,
  ConfigurationChangeRequestCreate = 15000,
  ConfigurationChangeRequestRead = 15001,
  ConfigurationChangeRequestUpdate = 15002,
  ConfigurationChangeRequestDelete = 15003,
  TroubleTicketCreate = 16000,
  TroubleTicketRead = 16001,
  TroubleTicketUpdate = 16002,
  TroubleTicketDelete = 16003,
  ExperimentationRead = 17001,
  TOReportRead = 18001,
  MainIncidentListRead = 19001,
  TOAndIncidentChartRead = 20001,
  LillCreate = 21000,
  LillRead = 21001,
  LillUpdate = 21002,
  LillDelete = 21003,
  LillObserverUpdate = 21012,
  LillProprietorUpdate = 21022,
  LillAnalystUpdate = 21032,
  LillTaskingAuthorityUpdate = 21042,
  LillActionBodyUpdate = 21052,
  TechnicalSupportRequestCreate = 22000,
  TechnicalSupportRequestRead = 22001,
  TechnicalSupportRequestUpdate = 22002,
  TechnicalSupportRequestDelete = 22003,
  RegistryCreate = 23000,
  RegistryRead = 23001,
  RegistryUpdate = 23002,
  RegistryDelete = 23003,
  SettingCreate = 24000,
  SettingRead = 24001,
  SettingUpdate = 24002,
  SettingDelete = 24003,
  ActorBooksCreate = 25000,
  ActorBooksRead = 25001,
  ActorBooksUpdate = 25002,
  ActorBooksDelete = 25003,
  GeostrategicSituationRead = 26001,
  RoadToCurrentSettingRead = 27001,
  WorkPackageCreate = 28000,
  WorkPackageRead = 28001,
  WorkPackageUpdate = 28002,
  WorkPackageDelete = 28003,
  TaskCreate = 29000,
  TaskRead = 29001,
  TaskUpdate = 29002,
  TaskDelete = 29003,
  ProjectInputCreate = 30000,
  ProjectInputRead = 30001,
  ProjectInputUpdate = 30002,
  ProjectInputDelete = 30003,
  KanbanCreate = 31000,
  KanbanRead = 31001,
  KanbanUpdate = 31002,
  KanbanDelete = 31003,
  DeliverableCreate = 32000,
  DeliverableRead = 32001,
  DeliverableUpdate = 32002,
  DeliverableDelete = 32003,
  TestCreate = 33000,
  TestRead = 33001,
  TestUpdate = 33002,
  TestDelete = 33003,
  HymotseCreate = 34000,
  HymotseRead = 34001,
  HymotseUpdate = 34002,
  HymotseDelete = 34003,
  FMMStateCreate = 35000,
  FMMStateRead = 35001,
  FMMStateUpdate = 35002,
  FMMStateDelete = 35003,
  FMMTransactionCreate = 36000,
  FMMTransactionRead = 36001,
  FMMTransactionUpdate = 36002,
  FMMTransactionDelete = 36003,
  PPMStateCreate = 37000,
  PPMStateRead = 37001,
  PPMStateUpdate = 37002,
  PPMStateDelete = 37003,
  PPMTransactionCreate = 38000,
  PPMTransactionRead = 38001,
  PPMTransactionUpdate = 38002,
  PPMTransactionDelete = 38003,
  RLSMStateCreate = 39000,
  RLSMStateRead = 39001,
  RLSMStateUpdate = 39002,
  RLSMStateDelete = 39003,
  RLSMTransactionCreate = 40000,
  RLSMTransactionRead = 40001,
  RLSMTransactionUpdate = 40002,
  RLSMTransactionDelete = 40003,
  LILLStateCreate = 41000,
  LILLStateRead = 41001,
  LILLStateUpdate = 41002,
  LILLStateDelete = 41003,
  LILLTransactionCreate = 42000,
  LILLTransactionRead = 42001,
  LILLTransactionUpdate = 42002,
  LILLTransactionDelete = 42003,
  PhaseCreate = 43000,
  PhaseRead = 43001,
  PhaseUpdate = 43002,
  PhaseDelete = 43003,
  LOECreate = 44000,
  LOERead = 44001,
  LOEUpdate = 44002,
  LOEDelete = 44003,
  PlanOrderReportProcessCreate = 45000,
  PlanOrderReportProcessRead = 45001,
  PlanOrderReportProcessUpdate = 45002,
  PlanOrderReportProcessDelete = 45003,
  DecisiveConditionsCreate = 46000,
  DecisiveConditionsRead = 46001,
  DecisiveConditionsUpdate = 46002,
  DecisiveConditionsDelete = 46003,
  ODTaskCreate = 47000,
  ODTaskRead = 47001,
  ODTaskUpdate = 47002,
  ODTaskDelete = 47003,
  EffectCreate = 48000,
  EffectRead = 48001,
  EffectUpdate = 48002,
  EffectDelete = 48003,
  WargamingTurnChartCreate = 49000,
  WargamingTurnChartRead = 49001,
  WargamingTurnChartUpdate = 49002,
  WargamingTurnChartDelete = 49003,
  TasksEffectDCReportRead = 50001,
  OperationalDesignReportRead = 51001,
  ODC2MStateCreate = 52000,
  ODC2MStateRead = 52001,
  ODC2MStateUpdate = 52002,
  ODC2MStateDelete = 52003,
  ODC2MTransactionCreate = 53000,
  ODC2MTransactionRead = 53001,
  ODC2MTransactionUpdate = 53002,
  ODC2MTransactionDelete = 53003,
  PPMProjectCreate = 54000,
  PPMProjectRead = 54001,
  PPMProjectUpdate = 54002,
  PPMProjectDelete = 54003,
  COAMCoaDevelopmentCreate = 55000,
  COAMCoaDevelopmentRead = 55001,
  COAMCoaDevelopmentUpdate = 55002,
  COAMCoaDevelopmentDelete = 55003,
  COAMSyncMatrixRead = 56001,
  COAMSyncMatrixUpdate = 56002,
  COAMRiskCreate = 57000,
  COAMRiskRead = 57001,
  COAMRiskUpdate = 57002,
  COAMRiskDelete = 57003,
  COAMCoaAnalysisCreate = 58000,
  COAMCoaAnalysisRead = 58001,
  COAMCoaAnalysisUpdate = 58002,
  COAMCoaAnalysisDelete = 58003,
  OMMStateCreate = 59000,
  OMMStateRead = 59001,
  OMMStateUpdate = 59002,
  OMMStateDelete = 59003,
  OMMTransactionCreate = 60000,
  OMMTransactionRead = 60001,
  OMMTransactionUpdate = 60002,
  OMMTransactionDelete = 60003,
  ODC2MRiskCreate = 61000,
  ODC2MRiskRead = 61001,
  ODC2MRiskUpdate = 61002,
  ODC2MRiskDelete = 61003,
}
